import { MenuResponse } from '@/main/models/response/menu';
import { MenuActionTypes, MenuTypes } from './menuTypes';

export function getMenu(): MenuActionTypes {
  return {
    type: MenuTypes.GET_MENU
  };
}

export function saveMenu(
  data: MenuResponse[] | null,
  isError: boolean,
  errorMessages: string[] | null
): MenuActionTypes {
  return {
    type: MenuTypes.SAVE_MENU,
    payload: { data, isError, errorMessages }
  };
}

export function resetReducerMenu(): MenuActionTypes {
  return {
    type: MenuTypes.RESET_REDUCER_MENU
  };
}

export function setMenuItemSelected(menuItemSelected: string): MenuActionTypes {
  return {
    type: MenuTypes.SET_MENU_ITEM_SELECTED,
    payload: { menuItemSelected }
  };
}

export function setOpenMenu(open: boolean): MenuActionTypes {
  return {
    type: MenuTypes.SET_OPEN_MENU,
    payload: { open }
  };
}
